import Vue from 'vue'

Vue.component('AccessForm', () => import('./access-form.vue'))
Vue.component('LockButton', () => import('./LockButton.vue'))
Vue.component('loading', () => import('./loading.vue'))
Vue.component('metodosPagoStripe', () => import('./metodosPago/metodosPagoStripe.vue'))
Vue.component('ui-loading', () => import('./loading.vue'))
Vue.component('check-mark-icon', () => import('./checkMarkIcon.vue'))
Vue.component('ui-dotlottie-loader', () => import('./ui-dotlottie-loader.vue'))